import React, { CSSProperties, ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import { lighten } from 'polished'
import colors from '../lib/colors'

const StyledSpan = styled.span`
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: underline;
  color: ${(props): string => (props.theme.length ? props.theme : colors.blue)};
  :hover {
    color: ${(props): string => (props.theme.length ? lighten(0.1, props.theme) : colors.lightBlue)};
  }
`
const StyledLink = styled.a`
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: underline;
  color: ${(props): string => (props.theme.length ? props.theme : colors.blue)};
  :hover {
    color: ${(props): string => (props.theme.length ? lighten(0.1, props.theme) : colors.lightBlue)};
  }
`

export interface IButtonlinkProps {
  children: ReactNode
  onClick?: () => void
  customColor?: string
  className?: string
  style?: CSSProperties
  title?: string
}
export function Buttonlink({
  children,
  onClick,
  customColor,
  className,
  style,
  title,
}: IButtonlinkProps): ReactElement {
  return (
    <StyledSpan
      theme={customColor}
      onClick={onClick}
      className={className}
      style={style}
      title={title}
    >
      {children}
    </StyledSpan>
  )
}

export interface IHyperlinkProps {
  children: ReactNode
  href: string
  customColor?: string
  className?: string
  style?: CSSProperties
  newTab?: boolean
  title?: string
}
function Hyperlink({
  children,
  href,
  customColor,
  className,
  style,
  newTab,
  title,
}: IHyperlinkProps): ReactElement {
  return (
    <StyledLink
      theme={customColor}
      href={href}
      className={className}
      style={style}
      target={newTab ? '_blank' : '_self'}
      title={title}
    >
      {children}
    </StyledLink>
  )
}
export default Hyperlink
